import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-title-with-button',
  templateUrl: './title-with-button.component.html',
  styleUrls: ['./title-with-button.component.css']
})
export class TitleWithButtonComponent {
  @Input() data!: any;
}
